import { useRef, useState } from 'react'

import { FormikAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
//import { exportClientsValidation } from "Components/Validation/Sales/Clients"
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { Form, Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const ExportCaja = ({ open, onClose, dataBefore }) => {
  const [loading, setLoading] = useState(false)
  const createDismissableSnackbar = useCustomSnackbar()
  const formikRef = useRef(null)

  const handleSubmit = () => {
    formikRef.current.submitForm()
  }

  const formatDate = (date) => {
    if (!date) return null
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const exportData = async (values) => {
    setLoading(true)
    const empresaId = values.origen?.id || values.origen
    const body = {
      empresa: empresaId,
      sucursal: values.sucursal,
      fechaDesde: formatDate(values.inicial),
      fechaHasta: formatDate(values.final),
    }

    await interfaces.salesCaja
      .exportCaja(body)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar('¡Cajas exportadas con éxito!', {
          variant: 'success',
        })
        onClose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal al exportar datos!', {
          variant: 'error',
        })
      })
    setLoading(false)
  }

  const enteprises = [
    { id: 1, label: 'ECO' },
    { id: 2, label: 'OEM' },
    { id: 3, label: 'DOS' },
  ]

  const SUCURSAL = [
    {
      id: 1,
      label: 'ECO Río Cuarto',
    },
    {
      id: 2,
      label: 'ECO Ruta 7',
    },
    {
      id: 3,
      label: 'ECO 25 de mayo',
    },
    {
      id: 4,
      label: 'Todas',
    },
  ]

  const today = new Date()

  const fields = (setFieldValue, values) => [
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label="Origen"
          name="origen"
          defaultValue={{ id: 1, label: 'ECO' }}
          options={enteprises}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('origen', value)
            setFieldValue('sucursal', null)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label={values.origen.label === 'ECO' ? 'Punto de venta' : 'Sucursal'}
          name="sucursal"
          options={values.origen?.label === 'ECO' ? dataBefore.data.punto_venta : SUCURSAL}
          getOptionLabel={(e) => {
            if (!e) return ''
            if (values.origen?.label === 'ECO') {
              return `${e.nombre} (${e.numero})`
            }
            return e.label
          }}
          onChange={(_, value) => {
            const val = values.origen?.label === 'ECO' ? value?.numero : value?.id
            setFieldValue('sucursal', val)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'datepicker',
      label: 'Fecha desde',
      format: 'dd-MM-yyyy',
      name: 'inicial',
      value: today,
      sm: 12,
      xs: 12,
    },
    {
      class: 'datepicker',
      label: 'Fecha hasta',
      format: 'dd-MM-yyyy',
      name: 'final',
      value: today,
      sm: 12,
      xs: 12,
    },
  ]

  return (
    <DialogComponent
      open={open}
      handleclose={onClose}
      title="Exportar cajas"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge="500px"
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={onClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
        />
      }
      children={
        <Formik
          innerRef={formikRef}
          initialValues={{
            origen: { id: 1, label: 'ECO' },
            sucursal: null,
            inicial: today,
            final: today,
          }}
          onSubmit={exportData}
          enableReinitialize
          //validationSchema={exportClientsValidation}
        >
          {({ setFieldValue, values }) => (
            <Form>
              <InputsWithValidate
                fields={fields(setFieldValue, values)}
                spacing={2}
                setFieldValue={setFieldValue}
              />
            </Form>
          )}
        </Formik>
      }
    />
  )
}

export default ExportCaja
